import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/role', component: List, name: 'role.index'},
  {path: '/role/store', component: Form, name: 'role.store'},
  {path: '/role/:id', component: Form, name: 'role.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/role/routes.js